export default __webpack_public_path__ + "static/lutein-restartirat-zrenieto-hd-5096b14787fa536a67a82c1cefed0645.jpg";